// Owner in P2: piece 12 "Network screen" (docs/FILE-OWNERSHIP.md).
// The feature's entry file (docs/CONTRACTS.md section 16): `/network`, one lazy chunk. The selected contact is the URL's
// `contact` search value, a contact id and nothing else (never free text); the omnibar's contact rows open it (21.10).
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { Contact } from 'lucide-react'
import type { Feature } from '../feature.ts'
import { parseSearch } from './queries.ts'

export const feature: Feature = {
  app: (parent) => [
    createRoute({
      getParentRoute: () => parent,
      path: '/network',
      validateSearch: (search: Record<string, unknown>) => parseSearch(search),
      component: lazyRouteComponent(() => import('./NetworkScreen.tsx')),
    }),
  ],
  nav: [{ to: '/network', label: 'nav.network', icon: Contact, group: 'network', key: 'n' }],
}
